// Entry point for the build script in your package.json
import "@hotwired/turbo-rails";
import "./controllers";
import "flowbite"; // Import Flowbite

document.addEventListener("turbo:load", () => {
  // Initialize Flowbite components after Turbo loads a page
  // This might vary depending on specific Flowbite version/setup
  // Often initFlowbite() is provided, or you might initialize specific components
  if (typeof initFlowbite === "function") {
    initFlowbite();
  }
  // Alternatively, init specific components if needed:
  // initTooltips();

  // Handle flash messages from sessionStorage
  const flashAlert = sessionStorage.getItem("flash_alert");
  if (flashAlert) {
    // Find flash container
    const flashContainer = document.getElementById("flash_messages");
    if (flashContainer) {
      // Create alert element matching the structure in _flash.html.erb
      const alertHtml = `
        <div
          class="absolute top-4 right-4 w-full max-w-xs sm:max-w-sm md:max-w-md pointer-events-auto"
          data-controller="flash"
          data-action="animationend->flash#remove"
          data-flash-delay-value="3000"
        >
          <div class="relative flex items-center p-4 pl-5 pr-10 mb-4 text-sm text-amber-200 rounded-sm bg-amber-800/90 border border-amber-700 shadow-lg" role="alert" data-flash-target="message">
            <svg class="flex-shrink-0 inline w-4 h-4 me-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
              <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5ZM9.5 4a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3ZM12 15H8a1 1 0 0 1 0-2h1v-3H8a1 1 0 0 1 0-2h2a1 1 0 0 1 1 1v4h1a1 1 0 0 1 0 2Z"/>
            </svg>
            <span class="sr-only">Error</span>
            <div class="flex-1">
              ${flashAlert}
            </div>
            <button type="button" class="absolute top-2 right-2 ml-auto -mx-1.5 -my-1.5 rounded-sm focus:ring-2 focus:ring-amber-400 p-1.5 hover:bg-amber-700/50 inline-flex items-center justify-center h-8 w-8 text-amber-200" data-action="click->flash#dismiss" aria-label="Close">
              <span class="sr-only">Close</span>
              <svg class="w-3 h-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14">
                <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"/>
              </svg>
            </button>
          </div>
        </div>
      `;
      // Add to the inner container
      flashContainer
        .querySelector(".relative")
        .insertAdjacentHTML("beforeend", alertHtml);
    }
    // Clear the flash message from storage
    sessionStorage.removeItem("flash_alert");
  }
});
